export const extractUsername = (str: string) => {
    if (!str) return "";
    return str.split("@")[0];
};
